import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Overlay from './overlay';
import MessageBox from './message_box';

const Modal = (props) => {
  const {
    actionSheet,
    className: classNameProp,
    onOverlayClick,
    overlayFullscreen,
  } = props;

  const className = classnames({
    'bvs-modal': true,
    'is-action-sheet': actionSheet,
    [classNameProp]: true,
  });

  return (
    <div className={`bvs-modal-container ${classNameProp ? `${classNameProp}-wrapper` : ''}`}>
      <Overlay fullscreen={overlayFullscreen} onClick={onOverlayClick} />
      <MessageBox {...props} className={className} />
    </div>
  );
};

Modal.propTypes = {
  className: PropTypes.string,
  actionSheet: PropTypes.bool,
  onOverlayClick: PropTypes.func,
  overlayFullscreen: PropTypes.bool,
};

Modal.defaultProps = {
  className: '',
  onOverlayClick: () => {},
  actionSheet: false,
  overlayFullscreen: false,
};

export default Modal;
